import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { api } from "../../api/client";
import type { Parfume } from "../../api/types";

export const createParfume = createAsyncThunk("parfumes/create", async (p: { name: string; img?: string; description?: string; question?: string; }) => {
  const res = await api<{ ok: true; parfume: Parfume }>("/client/create-parfume", { method: "POST", body: JSON.stringify(p) });
  return res.parfume;
});

export const finishOrder = createAsyncThunk("parfumes/finish", async () => {
  await api<{ ok: true }>("/client/finish", { method: "POST" });
  return true;
});

const slice2 = createSlice({
  name: "parfumes",
  initialState: { items: [] as Parfume[], status: "draft" as string, saving: false, error: "" },
  reducers: {
    setFromMe(state, action) {
      const user = action.payload as any; state.items = user.parfumes || []; state.status = user.status || "draft";
    }
  },
  extraReducers: b => {
    b.addCase(createParfume.fulfilled, (s,a) => { s.items.push(a.payload); })
     .addCase(finishOrder.pending, (s) => { s.saving = true; })
     .addCase(finishOrder.fulfilled, (s) => { s.saving = false; s.status = "ai_generated"; })
     .addCase(finishOrder.rejected, (s,a) => { s.saving = false; s.error = a.error.message || ""; });
  }
});
export const { setFromMe } = slice2.actions;
export default slice2.reducer;